import React from 'react';
import { Container, Row, Col, Fade } from 'reactstrap';
import { RouteComponentProps, withRouter } from 'react-router';
import { PractitionersTableCard } from '../../../containers/Cards/Practitioner';
import OrganizationProvider from '../../../containers/Providers/Organizations';
import PractitionerProvider from '../../../containers/Providers/Practitioner';

const PractitionerList = ({
  match,
}: RouteComponentProps<{ organizationId: string; practitionerId: string }>) => (
  <OrganizationProvider organizationId={match.params.organizationId}>
    <PractitionerProvider practitionerId={match.params.practitionerId}>
      <Fade>
        <Container fluid className="mt-3">
          <Row>
            <Col>
              <PractitionersTableCard></PractitionersTableCard>
            </Col>
          </Row>
        </Container>
      </Fade>
    </PractitionerProvider>
  </OrganizationProvider>
);
export default withRouter(PractitionerList);
